import Vue from 'vue';
import Router from 'vue-router';
import khi from '../vue/khi.vue';
import kurs from '../vue/kurs.vue';

Vue.use(Router);

export default new Router({
  base: '/index.php?id=377',
  routes: [
    {
      path: '/gruppe/:gruppeUID?/art/:artUID?',
      name: 'Kursliste',
      component: khi,
    },
    {
      path: '/kurs/:kursnummer',
      name: 'Kurs',
      component: kurs,
    },
  ],
});
